// extracted by mini-css-extract-plugin
export default {"l":"_83504ae177"};